import { combineReducers } from "redux";
import stdReducer from "./stdReducer";
import profileReducer from "./profileReducer";
import toastComponentReducer from "./toastReducer";
import loaderReducer from "./loaderReducer";
import { i18nState } from "redux-i18n";
import modalReducer from "./modalReducer";
import commonReducer from "./commonReducer";
import serviceReducer from "./serviceReducer";
import attachmentsReducer from "./attachmentsReducer";
import managerApplicantReducer from "./managerApplicantReducer";
import airReducer from "./airReducer";
import loginReducer from "./loginReducer";
import companyReducer from "./companyReducer";
import airAttachmentsReducer from "./airAttachmentsReducer";
import accomodationReducer from "./accomodationReducer";
import notification from "./notificationReducer";
import filterReducer from "./filterReducer";
import userAuthReducer from "./userAuthReducer";
import forgotPasswordReducer from "./forgotPasswordReducer";
import myApplicationsReducer from "./myApplicationsReducer";
import ccmReducer from "./ccmReducer";

export default combineReducers({
  i18nState,
  stdReducer,
  toastComponentReducer,
  loaderReducer,
  modalReducer,
  profileReducer,
  commonReducer,
  serviceReducer,
  attachmentsReducer,
  loginReducer,
  managerApplicantReducer,
  airReducer,
  companyReducer,
  airAttachmentsReducer,
  accomodationReducer,
  notification,
  filterReducer,
  userAuthReducer,
  forgotPasswordReducer,
  myApplicationsReducer,
  ccmReducer
});
